module.exports = __webpack_public_path__ + "static/media/prototype.8de59400.png";